/** Evenly spaced X-axis labels (ISO) without crowding narrow cards. */
export function buildEvenXAxisTicks(
  dates: string[],
  maxTicks: number
): string[] {
  if (dates.length === 0) return [];
  const tickCount = Math.min(Math.max(maxTicks, 2), dates.length);
  if (tickCount === 1) return [dates[0]];
  if (tickCount === 2) return [dates[0], dates[dates.length - 1]];

  const lastIndex = dates.length - 1;
  const indices = Array.from({ length: tickCount }, (_, i) =>
    Math.round((i / (tickCount - 1)) * lastIndex)
  );
  return [...new Set(indices.map((index) => dates[index]))];
}

/** Integer ticks for a fixed Y domain (avoids duplicate labels in Recharts). */
export function buildIntegerYAxisTicksForDomain(domainMax: number): number[] {
  const max = Math.max(Math.ceil(domainMax), 1);
  if (max <= 10) {
    return Array.from({ length: max + 1 }, (_, i) => i);
  }
  const step = max <= 50 ? 5 : max <= 200 ? 20 : 50;
  const ticks: number[] = [0];
  for (let t = step; t < max; t += step) {
    ticks.push(t);
  }
  if (!ticks.includes(max)) {
    ticks.push(max);
  }
  return ticks;
}
